/*!Copyright 2010 karmadata, Inc. **/
/**kd.api.data requires these libraries to be loaded first
* jQuery
* Underscore.js
* moment.js
*/

var _ = {}
_.each = require('lodash.foreach')
_.indexOf = require('lodash.indexof')
_.flattenDeep = require('lodash.flattendeep')

var SortOrder = (function () {
    return function () {
        //Private Variables
        var orderByList = [];

        //Private Functions
        var getSortOrderModelValues = function () {
            var orderBys = [];
            _.each(orderByList, function (item, index) {
                orderBys.push(item.getSortOrderModelItemValue());
            });
            return orderBys;
        }
        var removeSortOrderFromList = function (orderByToRemove) {
            _.each(orderByList, function (item, index) {
                if (orderByToRemove.getPropertyName() === item.getPropertyName()) {
                    orderByList.splice(index, 1); // at position index remove one item
                }
            });
            return orderByList;
        }
        var rejectOrderBy = function (orderByIn) {
            return !orderByIn; //for now just return true or false if filter is null
        }
        //Public Variables
        //None for this closure

        //Privileged functions, can access both public and private
        //We need functions here to do protected get and set
        //and to do error checking and handling
        this.addSortOrderItem = function (propertyNameIn, directionIn) {
            var orderByAdded = new SortOrderItem(propertyNameIn, directionIn);
            if (rejectOrderBy(orderByAdded)) return "A valid OrderBy Object is required";
            else {
                orderByList.push(orderByAdded);
                return orderByList;
            }
        };
        this.removeSortOrderItem = function (orderByIn) {
            if (rejectOrderBy(orderByIn)) return "A valid OrderBy Object is required";
            else {
                removeSortOrderFromList(orderByIn);
                return orderByList;
            }
        };
        this.setSelected = function (selectedValues) {
            if (typeof selectedValues === "undefined") {
                throw "setSelected requires a list of objects {direction, propertyName}";
            } else {
                orderByList = []; //ToDo, garbage collection?
                _.each(selectedValues, function (sortOrder, index) {
                    var orderByAdded = new SortOrderItem(sortOrder.propertyName, sortOrder.direction);
                    orderByList.push(orderByAdded);
                });
            }

        };
        this.clearSortOrder = function () {
            orderByList = [];
        };
        this.getSortOrderModelValue = function () {
            var orderByListStruct = getSortOrderModelValues();
            //            var value = {
            //                "KdOrderByList": orderByListStruct
            //            }
            //            return value;
            return orderByListStruct;
        }

    };
})();

var SortOrderItem = (function () {
    return function (propertyNameIn, directionIn) {
        /** Private Variables */
        /** The KdEntity property that we are filtering on*/
        var propertyName = propertyNameIn;
        /**
        * Valid Direction values are: asc|desc
        */
        var direction = directionIn;  //
        /** Private Functions */
        var errorCheckDirection = function (directionToCheck) {
            if (_.indexOf(["asc", "desc"], directionToCheck) === -1) {
                throw directionToCheck + " is not a valid OrderBy Direction.  Valid Direction values are asc|desc";
            };
        };
        var errorCheckInitState = function () {
            if (!propertyName) {
                throw "The OrderBy does not have an PropertyName set";
            }

            if (!direction) {
                throw "The OrderBy does not have an direction set";
            }
            errorCheckDirection(direction);
        };
        var setSelected = function (selectedValue) {
            if (!selectedValue.direction || !selectedValue.propertyName) {
                throw "setSelected requires an object of {direction, propertyName}";
            } else {
                direction = selectedValue.direction;
                propertyName = selectedValue.propertyName;
                return selectedValue;
            }
        };
        var init = function () {
            errorCheckInitState();
        };
        /** Public Variables */


        //Privileged functions, can access both public and private
        //We need functions here to do error checking and handling
        this.getDirection = function () {
            return direction;
        };
        this.setDirection = function (orderByDirection) {
            if (!orderByDirection) {
                throw "A valid OrderBy Direction is required";
            }
            else {
                direction = orderByDirection;
                return direction;
            }
        };
        this.getPropertyName = function () {
            return propertyName;
        };
        this.setPropertyName = function (orderByPropertyName) {
            if (!orderByPropertyName) {
                throw "A valid OrderBy PropertyName is required";
            }
            else {
                propertyName = orderByPropertyName;
                return propertyName;
            }
        };
        this.setSelected = function (selectedValue) {
            if (typeof selectedValue === "undefined") {
                throw "setSelected requires an object of {direction, propertyName}";
            } else {
                setSelected(selectedValue);
                return selectedValue;
            }

        };
        /** Returns a struct that can be passed to the kd API as a filter (part of a FilterList)*/
        this.getSortOrderModelItemValue = function () {
            var filter = {};
            filter.direction = direction;
            filter.propertyName = propertyName;
            /**
            * Error handling
            */
            errorCheckInitState();

            return filter;
        };

        /** Init functions*/

        init();

    };
})();

exports.SortOrder = SortOrder
exports.SortOrderItem = SortOrderItem



//////////////////
// WEBPACK FOOTER
// ./~/karmadata/kd.api.data/kd.api.data.SortOrder.js
// module id = 230
// module chunks = 0